<div class="p-3">
    v{{ environmentsInformation.app.version }} - {{ environmentsInformation.app.name }}<br>
    v{{ environmentsInformation.server.version }} - {{ environmentsInformation.server.name }}
</div>